@if (!titleClass) {
    <mat-label>Comments</mat-label>
}
@if (titleClass) {
    <div [class]="titleClass">Comments</div>
}

<div class="flex flex-col w-full mt-4" style="gap: 1rem">
    @for (comment of comments; track comment) {
        <div>
            <div
                class="flex flex-row"
                [class.editing-comment]="currentId == comment.id"
            >
                <div class="flex-1">
                    <div class="italic whitespace-pre-line">
                        {{ comment.text }}
                    </div>
                    <div class="text-sm mt-2" style="color: black">
                        {{ comment.timeStamp | date: "dd/MM/yyyy HH:mm" }} by
                        {{ GetUserName(comment.userId) | titlecase }}
                    </div>
                </div>
                @if (canEditComment(comment)) {
                    <button
                        mat-icon-button
                        class="w-8 h-8 min-h-8"
                        style="margin-right: -4px"
                        (click)="openCommentEdit(comment)"
                    >
                        <mat-icon
                            class="icon-size-4"
                            [svgIcon]="'heroicons_solid:pencil'"
                        ></mat-icon>
                    </button>
                }
                @if (canEditComment(comment)) {
                    <button
                        mat-icon-button
                        class="w-8 h-8 min-h-8"
                        (click)="deleteComment(comment.id)"
                    >
                        <mat-icon
                            class="icon-size-4"
                            [svgIcon]="'heroicons_solid:trash'"
                        ></mat-icon>
                    </button>
                }
            </div>
        </div>
    }

    <mat-form-field class="w-full mt-2" [subscriptSizing]="'dynamic'">
        <textarea
            matInput
            [(ngModel)]="currentText"
            [placeholder]="'Add a comment...'"
            [rows]="2"
            cdkTextareaAutosize
            [cdkAutosizeMinRows]="1"
        >
        </textarea>
    </mat-form-field>

    @if (!editingComment) {
        <button
            mat-flat-button
            style="width: fit-content"
            [color]="'primary'"
            (click)="saveButtonClicked()"
        >
            <mat-icon
                class="text-hint"
                [svgIcon]="'heroicons_outline:plus'"
            ></mat-icon>
            <span class="ml-1">{{ editingComment ? "Save" : "Add" }}</span>
        </button>
    }
    @if (editingComment) {
        <div
            class="flex flex-row justify-end"
            style="margin-top: -0.75rem; height: 52px"
        >
            <button
                mat-icon-button
                class="w-8 h-8 min-h-8"
                style="margin-right: -4px"
                (click)="wipeComment()"
            >
                <mat-icon
                    class="icon-size-5"
                    [svgIcon]="'mat_solid:cancel'"
                ></mat-icon>
            </button>
            <button
                mat-icon-button
                class="w-8 h-8 min-h-8"
                (click)="saveButtonClicked()"
            >
                <mat-icon
                    class="icon-size-5"
                    [svgIcon]="'heroicons_solid:check-circle'"
                    style="color: var(--fuse-primary) !important"
                ></mat-icon>
            </button>
        </div>
    }
</div>
